import { render, staticRenderFns } from "./CompHintsCard.vue?vue&type=template&id=1384c29d"
import script from "./CompHintsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompHintsCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports